import builder from '@builder.io/react';
import { BuilderModels } from '../../../helpers/constants';

export const getOfferingGroups = async (): Promise<any[]> => {
  return builder.getAll(BuilderModels.OFFERING_GROUP, {
    fields: 'data',
    options: { noTargeting: true, includeRefs: true },
  });
};
